export default __webpack_public_path__ + "static/media/EM0820.34I-22034_-25388_0.071d7eda.jpg";